<template>
   <table class="w-100 mt-3 table-border-thick table" style="border-width: 3px;">
        <tbody>
            <tr>
                <td>
                    <h3>{{ $t('report.bySections') }}</h3>
                    <table class="w-100 table-sm table-borderless" v-for="section in report.sections" :key="section.section_code">
                        <tbody>
                            <tr>
                                <th colspan="3">{{ $t('report.section') }} {{ section.section_code }}</th>
                            </tr>
                            <tr>
                                <td class="align-top flex-grow-1" style="width:20%;">{{ section.operations.sell.count }}</td>
                                <td class="align-top flex-grow-1">{{ $t(`report.sell`) }}</td>
                                <td class="flex-shrink-1" align="right">
                                    {{ section.operations.sell.sum }}&nbsp;&#8376;
                                </td>
                            </tr>
                            <tr>
                                <td class="align-top flex-grow-1" style="width:20%;">{{ section.operations.buy.count }}</td>
                                <td class="align-top flex-grow-1">{{ $t(`report.buy`) }}</td>
                                <td class="flex-shrink-1" align="right">
                                    {{ section.operations.buy.sum }}&nbsp;&#8376;
                                </td>
                            </tr>
                            <tr>
                                <td class="align-top flex-grow-1" style="width:20%;">{{ section.operations.sell_return.count }}</td>
                                <td class="align-top flex-grow-1">{{ $t(`report.sellReturn`) }}</td>
                                <td class="flex-shrink-1" align="right">
                                    {{ section.operations.sell_return.sum }}&nbsp;&#8376;
                                </td>
                            </tr>
                            <tr>
                                <td class="align-top flex-grow-1" style="width:20%;">{{ section.operations.buy_return.count }}</td>
                                <td class="align-top flex-grow-1">{{ $t(`report.buyReturn`) }}</td>
                                <td class="flex-shrink-1" align="right">
                                    {{ section.operations.buy_return.sum }}&nbsp;&#8376;
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
export default {
    name: 'SectionReportDetails',
    props: {
        report: Object
    }
}
</script>
